import { observer } from "mobx-react";
import FontBody1 from "../../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../../../components/fonts/font-props";
import { DefaultModalLayout } from "../../../../../../../components/modal/layouts/default-modal-layout";
import YouTubePlayer from "../../../../../../../components/youtube-player/youtube-player";
import merchantVideoStore from "../../../../../../../stores/merchant-video-store";
import { getVideoIdFromYTLink } from "../../../../../../../services/helpers";
import "./help-video-modal.scss";
import YTVideoPlayListStore from "../../../../../../../stores/yt-video-playlist-store";
import { useEffect, useMemo } from "react";
import { Tabs } from "../../../../../../../components/tabs/tabs";

interface IProps {
    onCloseClicked: () => void;
    isOpen: boolean;
}

const HelpVideoModal: React.FC<IProps> = observer(({ onCloseClicked, isOpen }) => {

    const playList = useMemo(() => new YTVideoPlayListStore(), []);

    useEffect(() => {
        if (!merchantVideoStore.dashboardVideosLoaded) {
            merchantVideoStore.load();
        }
    }, []);

    if (!isOpen) {
        return null;
    }

    const onSetPlayerInstance = (playerId: string, player: YT.Player) => {
        playList.appendToPlayList(playerId, player);
    }

    /* TODO: replace videoObject.name with translation */
    const videoTabs = merchantVideoStore.dashboardVideos.map(videoObject => ({
        label: videoObject.name,
        content: (
            <YouTubePlayer
                onSetPlayerInstance={onSetPlayerInstance}
                videoId={getVideoIdFromYTLink(videoObject.link)}
            />
        ),
        onClick: playList.stopAllPlayersVideos
    }));

    return (
        <DefaultModalLayout onCloseClicked={onCloseClicked} isCloseDisabled={false}>
            <div className="help-video-modal-content">
                {/** TODO: replace with translation */}
                <FontBody1 color={FONT_COLOR.NEUTRAL3}>Video tutorials</FontBody1>
                <Tabs tabs={videoTabs} />
            </div>
        </DefaultModalLayout>
    );
});

export default HelpVideoModal;